import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core";
import { Observable } from "rxjs";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { FlexLayoutModule } from "ngx-flexible-layout";

import { TemplateService } from "../../service/template.service";
import { TemplateContent } from "../../model/TemplateRulebook";
import { AlertifyService } from "../../../_models/alertify.service";

@Component({
  selector: "app-list-rulebook",
  templateUrl: "./list-rulebook.component.html",
  styleUrls: ["./list-rulebook.component.css"],
  standalone: false,
})
export class ListRulebookComponent implements OnInit {
  @Input() rbList: TemplateContent[];
  @Input() selected: string;
  @Input() csskey: number;
  @Input() auditName: string;
  @Output() selectedAppkey = new EventEmitter<number>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: TemplateService,
    private alertifyService: AlertifyService,
    private el: ElementRef,
  ) {}

  private scrollActiveIntoView() {
    setTimeout(() => {
      const activeEl = this.el.nativeElement.querySelector(".active");
      if (activeEl)
        activeEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  }

  ngOnInit() {
    this.service.setKey(parseInt(this.selected));
  }

  onClickRulebook(appkey: number, rbName: string, abrided: boolean) {
    if (abrided) return;
    //console.log("click on rulebook: " + appkey);
    this.service.setRbName(rbName);
    this.service.setKey(appkey);
    this.selectedAppkey.emit(appkey);
    this.scrollActiveIntoView();
  }

  onBackSummary() {
    var myurl = "audithub/apptool/edit/" + this.csskey;
    this.router.navigateByUrl(myurl).then((err) => {
      console.log(err);
    });
  }

  onNextRulebook() {
    var values = this.service.getNextAppkey();
    if (values != null && values.first != 0) {
      var nextAppkey = values.first;
      var nextRbName = values.second;

      this.service.setKey(nextAppkey);
      this.service.setRbName(nextRbName);
      this.selectedAppkey.emit(nextAppkey);
      this.scrollActiveIntoView();
    } else {
      //alert("You have reached the end of the Applicability Questions!");
      this.alertifyService.warning(
        "You have reached the end of the Applicability Questions!",
      );
    }
  }

  onPreviousRulebook() {
    var values = this.service.getPreviousAppkey();
    if (values != null) {
      var nextAppkey = values.first;
      var nextRbName = values.second;

      this.service.setKey(nextAppkey);
      this.service.setRbName(nextRbName);
      this.selectedAppkey.emit(nextAppkey);
      this.scrollActiveIntoView();
    } else {
      //alert("You have reached the end of the Applicability Questions!");
      this.alertifyService.warning(
        "You have reached the beginning of the Applicability Questions!",
      );
    }
  }
}
